/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * X-Y location of diagram factor
 */
import { ValidateUtils } from 'app/shared/utils';

export class DiagramFactorLocationType { 
    /**
     * X-axis
     */
    x?: number;
    /**
     * Y-axis
     */
    y?: number;

    constructor(item?: Partial<DiagramFactorLocationType>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            x: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.x : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            y: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.y : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: DiagramFactorLocationType.isValid,
        };
    }

    static isValid(obj: DiagramFactorLocationType): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = DiagramFactorLocationType.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.x.isValid(item);
            result = result && validationObject.y.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

